import { EXPIRATION_LEAD_TIME_SECONDS } from "../auth/userServices";
import { useAppSelector } from "../store/hooks";

export const useIsUserAuthenticated = () => {
  const expires_at = useAppSelector((state) => state.auth.expires_at);
  const currTime = Math.floor(new Date().getTime() / 1000);
  const email = useAppSelector((state) => state.auth.email);

  return (): boolean => {
    return (
      email !== null &&
      email.trim() !== "" &&
      expires_at - EXPIRATION_LEAD_TIME_SECONDS > currTime
    );
  };
};
